import React from 'react';

const ShiftILibrary = () => {
  return (
    <div>
      ShiftILibrary
      ShiftILibrary
    </div>
  );
}

export default ShiftILibrary;
